// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3154":"css/admin-app.6820","7925":"css/app.6820"}[chunkId] + ".css";
};